import { render, staticRenderFns } from "./RazorpayPaymentMethod.vue?vue&type=template&id=fe0728ac&"
import script from "./RazorpayPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./RazorpayPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports